export async function convertToWebP(base64String) {
    const image = new Image();
    image.src = 'data:image/jpeg;base64,' + base64String;

    return new Promise((resolve, reject) => {
        image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = 350;
            canvas.height = 350

            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, 350, 350);

            canvas.toBlob(
                blob => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        const result = reader.result.split(',')[1]; // Rimuovi il prefisso 'data:image/jpeg;base64,'
                        resolve(result);
                    };
                },
                'image/webp',
                0.8 // Qualità della compressione, da 0 a 1
            );
        };

        image.onerror = error => reject(error);
    });
}

export function generateRandomFileName() {
    const timestamp = new Date().getTime();
    const randomString = Math.random().toString(36).substring(2, 8);
    return `image_${timestamp}_${randomString}.webp`;
}
